<section class="loading">
    <img src="assets/imgs/general-spinner.gif" />
</section>
